export default "__VITE_ASSET__D26WTTW5__"